import HomeProducts from '../components/HomeProducts';
import { NonOrderableProducts } from '../components/NonOrderableProducts';
import ProductCards from '../components/ProductCards';
import { ListMedicationsProps } from '../interface/interface';

export const ListMedications = ({
  products,
  addProductToCart,
  removeProductFromCart,
  nonOrderable,
  isHome,
}: ListMedicationsProps) => {
  

  return (
    <div>
      {isHome && products?.length ? (
        <ul className="grid grid-cols-1 gap-4 sm-land:grid-cols-2 lg:grid-cols-4">
          <HomeProducts
            products={products}
            totalProducts={products.length}
            addProductToCart={addProductToCart}
            removeProductFromCart={removeProductFromCart}
          />
          {nonOrderable?.length ? (
            <NonOrderableProducts
              data={nonOrderable}
              enableShopAllMedications={false}
            />
          ) : null}
        </ul>
      ) : !isHome && (products?.length || nonOrderable?.length) ? (
        <ul className="grid grid-cols-1 gap-4 sm-land:grid-cols-2 lg:grid-cols-4">
          {products?.length ? (
            <>
              {products.map((product, index) => (
                <div key={index}>
                  <ProductCards
                    product={product}
                    addProductToCart={addProductToCart}
                    removeProductFromCart={removeProductFromCart}
                    isAccessories={false}
                    allowedProduct={product?.allowedProducts?.length}
                  />
                </div>
              ))}
            </>
          ) : null}

          {nonOrderable?.length ? (
            <NonOrderableProducts
              data={nonOrderable}
              enableShopAllMedications={false}
            />
          ) : null}
        </ul>
      ) : (
        <div>No Products found to display</div>
      )}
    </div>
  );
};
